const getEnvValue = (key) => { // 환경변수 가져오는 헬퍼 함수
    if (window.__ENV__ && window.__ENV__[key]) { // 런타임 환경 (production)
        return window.__ENV__[key];
    }
  
    return process.env[`REACT_APP_${key}`]; // 개발 환경 폴백
};

// 환경변수 값들
const API_SERVER = getEnvValue('API_SERVER');
const WEB_SOCKET_SERVER = getEnvValue('WEB_SOCKET_SERVER');

export const SERVER_URL = API_SERVER;
export const WEBSOCKET_URL = `${WEB_SOCKET_SERVER}/api/chat/ws`;